module.exports = __webpack_public_path__ + "static/media/discoursea675aada.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/discourse.svg
// module id = 1325
// module chunks = 0